import { brandName, returnsCenterLink } from 'config';
import { UserStatus } from '@vue-util/cookie';

export default {
  routes: () => [
    {
      name: 'Purchases',
      path: '/purchases',
      beforeEnter: (to, from, next) => {
        if (process.env.NODE_ENV === 'development') {
          next();
        } else if (typeof document === 'object' && !UserStatus.isSignedIn() && !to?.query?.o) {
          next('/purchases/lookup');
        } else if (to?.path === '/purchases/online' && to?.query?.o) {
          next({ name: 'OrderViewByTokenOnly', query: { ...to?.query } });
        } else {
          next();
        }
      },
      component: () => import('@/components/pages/ppe/OrderHistoryView'),
      meta: {
        class: 'cell small-12 large-auto',
      },
      children: [
        {
          name: 'online-history',
          path: 'online',
          component: () => import('@/components/pages/ppe/OnlineHistory'),
        },
        {
          name: 'in-store-history',
          path: 'store',
          component: () => import('@/components/pages/ppe/InStoreHistory'),
        },
        {
          name: 'redirect-to-online-history',
          path: '',
          redirect: { name: 'online-history' },
        },
      ],
    },
    {
      name: 'OrderViewByTokenOnly',
      path: '/purchases/order-details',
      beforeEnter: (to, from, next) => {
        if (!to?.query?.o) {
          // this condition should never be true.
          next({ name: 'online-history', query: { ...to?.query } });
        } else {
          next();
        }
      },
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'Order Details',
        },
      },
      component: () => import('@/components/pages/ppe/OrderDetailsView'),
    },
    {
      name: 'Order Status',
      path: '/purchases/lookup',
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'Order Status',
        },
      },
      component: () => import('@/components/pages/ppe/OrderLookupView'),
    },
    {
      name: 'Order Details',
      path: '/purchases/online/:orderNumber',
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'Order Details',
        },
      },
      component: () => import('@/components/pages/ppe/OrderDetailsView'),
    },
    {
      name: 'Purchase Details',
      path: '/purchases/store/:receiptNumber',
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'Purchase Details',
        },
      },
      component: () => import('@/components/pages/ppe/PurchaseDetailsView'),
    },
    {
      name: 'Track Package',
      path: '/purchases/tracking',
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'Track Package',
        },
      },
      component: () => import('@/components/pages/ppe/TrackPackageView'),
    },
    {
      name: 'International Lookup',
      path: '/purchases/international',
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'International Lookup',
        },
      },
      component: () => import('@/components/pages/ppe/InternationalLookupView'),
    },
    {
      name: 'Schedule Delivery',
      path: '/purchases/scheduledelivery',
      component: () => import('@nuxt-common/schedule-delivery/app/components/SalesCheckLookup.vue'),
      meta: {
        class: 'cell small-12 large-7',
      },
    },
    {
      name: 'Return Details',
      path: '/purchases/returns',
      meta: {
        class: 'cell small-12 large-auto',
        seo: {
          title: 'Return Details',
        },
      },
      component: () => import('@/components/pages/returns/wrapper/ReturnDetailsWrapper.vue'),
    },
    {
      name: 'Return Items',
      path: '/my-orders/returns/select-items',
      meta: {
        layout: 'full-container',
        seo: {
          title: 'Order Returns',
        },
      },
      component: () => import('@/components/pages/returns/ReturnItemsView.vue'),
    },
    {
      name: 'Return Confirmation',
      path: '/my-orders/returns/confirmation',
      meta: {
        layout: 'full-container',
        seo: {
          title: 'Order Returns',
        },
      },
      component: () => import('@/components/pages/returns/wrapper/ReturnConfirmationWrapper.vue'),
    },
    {
      name: 'DeepLink Get Label',
      path: '/my-orders/returns/get-label',
      meta: {
        layout: 'full-container',
        seo: {
          title: 'Order Returns',
        },
      },
      component: () => import('@/components/pages/returns/DeepLinkGetLabel.vue'),
    },
    {
      name: 'Easy Return',
      path: '/purchases/easyreturns',
      meta: {
        layout: 'full-container',
        seo: {
          title: 'Easy Returns',
        },
      },
      component: () => import('@/components/pages/returns/EasyReturn.vue'),
    },
    {
      name: 'Gift Return',
      path: '/returns/gifts',
      meta: {
        layout: 'full-container',
        seo: {
          title: 'Gift Return',
        },
      },
      component: () => import('@/components/pages/returns/GiftReturn.vue'),
    },
    {
      name: 'Returns Center',
      path: '/returns',
      meta: {
        layout: 'full-container',
        seo: {
          title: 'Returns Center',
          description: `Start your free return and learn more about our returns and exchanges policies at ${brandName}.`,
          index: true,
          link: returnsCenterLink,
        },
      },
      component: () => import('@/components/pages/returns/ReturnsCenter.vue'),
    },
    // {
    //   name: 'Catch All',
    //   path: '/:pathMatch(.*)*',
    //   redirect: '/purchases/online',
    // },
  ],
};
